// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Button } from "@/components/ui/button";
// import {
//   Download,
//   Calendar,
//   Search,
//   Award,
//   X,
//   ExternalLink,
//   ArrowRight,
// } from "lucide-react";
// import heroImage from "@/assets/hero-training.jpg";
// import CustomCourseForm from "@/components/CustomCourseForm";
// import ConsultationForm from "@/components/ConsultationForm";
// import RealTimeSearch from "@/components/RealTimeSearch";
// import slogan from "../assets/slogan-white.svg";
// import { useLanguage } from "@/hooks/useLanguage";

// const HeroSection = () => {
//   const [isCustomCourseFormOpen, setIsCustomCourseFormOpen] = useState(false);
//   const [isConsultationFormOpen, setIsConsultationFormOpen] = useState(false);
//   const [showSearch, setShowSearch] = useState(false);
//   const [showWelcomePopup, setShowWelcomePopup] = useState(false);
//   const navigate = useNavigate();
//   const { isRTL } = useLanguage();

//   // Show welcome popup after delay
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowWelcomePopup(true);
//     }, 1000);

//     return () => clearTimeout(timer);
//   }, []);

//   // Only block scroll when modals are open
//   useEffect(() => {
//     if (showWelcomePopup || showSearch || isCustomCourseFormOpen || isConsultationFormOpen) {
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = 'unset';
//     }

//     return () => {
//       document.body.style.overflow = 'unset';
//     };
//   }, [showWelcomePopup, showSearch, isCustomCourseFormOpen, isConsultationFormOpen]);

//   const handleSearchCourses = () => {
//     setShowSearch(true);
//   };

//   const closeWelcomePopup = () => {
//     setShowWelcomePopup(false);
//   };

//   return (
//     <>
//       <CustomCourseForm
//         isOpen={isCustomCourseFormOpen}
//         onClose={() => setIsCustomCourseFormOpen(false)}
//       />

//       <ConsultationForm
//         isOpen={isConsultationFormOpen}
//         onClose={() => setIsConsultationFormOpen(false)}
//       />

//       {/* Welcome Popup Modal - Compact */}
//       {showWelcomePopup && (
//         <div
//           className="fixed inset-0 z-[60] bg-black/40 backdrop-blur-sm flex items-center justify-center p-4"
//           onClick={closeWelcomePopup}
//         >
//           <div
//             className="bg-white rounded-xl shadow-2xl max-w-sm w-full relative animate-in zoom-in-95 duration-200"
//             onClick={(e) => e.stopPropagation()}
//             dir={isRTL ? "rtl" : "ltr"}
//           >
//             <button
//               onClick={closeWelcomePopup}
//               className={`absolute top-2 z-10 text-gray-400 hover:text-gray-600 transition-colors p-1 ${
//                 isRTL ? "left-2" : "right-2"
//               }`}
//               aria-label={isRTL ? "إغلاق" : "Close"}
//             >
//               <X className="h-4 w-4" />
//             </button>

//             {/* Minimal decorative dots */}
//             <div className={`absolute top-4 w-2 h-2 bg-ecosafe-green rounded-full opacity-50 ${
//               isRTL ? "right-4" : "left-4"
//             }`}></div>
//             <div className={`absolute bottom-4 w-2 h-2 bg-ecosafe-green rounded-full opacity-50 ${
//               isRTL ? "left-4" : "right-4"
//             }`}></div>

//             <div className="p-6 text-center">
//               <div className="mb-3 flex justify-center">
//                 <div className="w-12 h-12 bg-gradient-to-br from-ecosafe-green to-ecosafe-green-dark rounded-xl flex items-center justify-center shadow-md">
//                   <Award className="h-6 w-6 text-white" />
//                 </div>
//               </div>

//               <h3 className="text-lg font-bold text-ecosafe-black mb-2">
//                 {isRTL
//                   ? "للحصول على آخر الوظائف والتحديثات!"
//                   : "Get Latest Jobs & Updates!"}
//               </h3>

//               <p className="text-gray-600 text-sm mb-4 leading-snug">
//                 {isRTL
//                   ? "تابعنا للحصول على التحديثات الحصرية والفرص التدريبية"
//                   : "Follow us for exclusive updates and training opportunities"}
//               </p>

//               <a
//                 href="https://www.linkedin.com/company/ecosafe-for-training-and-consultancy-services/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="block"
//               >
//                 <Button
//                   className="w-full bg-gradient-to-r from-ecosafe-green to-ecosafe-green-dark hover:brightness-110 text-white font-semibold py-2.5 px-4 rounded-lg transition-all duration-200 shadow-md text-sm"
//                   onClick={closeWelcomePopup}
//                 >
//                   <ExternalLink className={`h-4 w-4 ${isRTL ? "ml-2" : "mr-2"}`} />
//                   {isRTL ? "تابعنا على لينكدإن" : "Follow on LinkedIn"}
//                   <ArrowRight className={`h-4 w-4 ${isRTL ? "mr-2 rotate-180" : "ml-2"}`} />
//                 </Button>
//               </a>

//               <button
//                 onClick={closeWelcomePopup}
//                 className="mt-3 text-gray-400 hover:text-gray-600 text-xs font-medium transition-colors"
//               >
//                 {isRTL ? "تخطي" : "Skip"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Search Overlay */}
//       {showSearch && (
//         <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
//           <div
//             className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-ecosafe-green/20 w-full max-w-2xl"
//             dir={isRTL ? "rtl" : "ltr"}
//           >
//             <div className="p-6">
//               <div className="flex items-center justify-between mb-6">
//                 <h3 className="text-2xl font-bold text-ecosafe-black">
//                   {isRTL ? "البحث عن الدورات التدريبية" : "Search Training Courses"}
//                 </h3>
//                 <Button
//                   variant="ghost"
//                   size="icon"
//                   onClick={() => setShowSearch(false)}
//                   className="text-ecosafe-gray hover:text-ecosafe-green-dark hover:bg-ecosafe-green/10 rounded-full"
//                 >
//                   <X className="h-5 w-5" />
//                 </Button>
//               </div>
//               <RealTimeSearch onClose={() => setShowSearch(false)} />
//             </div>
//           </div>
//         </div>
//       )}

//       {/* *** OPTIMIZED HERO SECTION *** */}
//       <section
//         className="relative min-h-screen flex items-center justify-center py-8"
//         dir={isRTL ? "rtl" : "ltr"}
//       >
//         {/* Background with light overlay */}
//         <div className="absolute inset-0 z-0">
//           <img
//             src={heroImage}
//             alt={isRTL ? "بيئة تدريب مهنية" : "Professional training environment"}
//             className="w-full h-full object-cover"
//           />
//           <div className="absolute inset-0 bg-gradient-to-r from-ecosafe-black/50 via-ecosafe-black/30 to-ecosafe-black/15" />
//         </div>

//         {/* Main Content */}
//         <div className="relative z-10 container mx-auto px-4">
//           <div className="grid lg:grid-cols-2 gap-8 items-center">
//             {/* Left Side - Content */}
//             <div className="text-center lg:text-left">
//               {/* Badge */}
//               <div className="inline-flex items-center gap-2 px-4 py-2 mb-6 bg-white/10 backdrop-blur-md rounded-full text-white border border-white/20">
//                 <Award className="h-4 w-4 text-ecosafe-green" />
//                 <span className="text-sm font-medium">
//                   {isRTL ? "٢٥٠٠+ برنامج تدريبي" : "2500+ Training Programs"}
//                 </span>
//               </div>

//               {/* Slogan */}
//               <div className="mb-8">
//                 <img
//                   src={slogan}
//                   alt={isRTL ? "تدرب لتقود، تعلم مع إيكوسيف" : "Train to Lead, Learn with ECOSAFE"}
//                   className="w-64 lg:w-80 h-auto mx-auto lg:mx-0"
//                 />
//               </div>

//               {/* Stats */}
//               <div className="flex justify-center lg:justify-start gap-6 mb-8">
//                 <div className="text-center">
//                   <div className="text-2xl font-bold text-white">3K+</div>
//                   <div className="text-white/80 text-sm">{isRTL ? "محترف" : "Professionals"}</div>
//                 </div>
//                 <div className="text-center">
//                   <div className="text-2xl font-bold text-white">25+</div>
//                   <div className="text-white/80 text-sm">{isRTL ? "دولة" : "Countries"}</div>
//                 </div>
//                 <div className="text-center">
//                   <div className="text-2xl font-bold text-white">60+</div>
//                   <div className="text-white/80 text-sm">{isRTL ? "شركة" : "Companies"}</div>
//                 </div>
//               </div>

//               {/* Download Buttons */}
//               <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
//                 <a
//                   href={
//                     isRTL
//                       ? "https://drive.google.com/uc?export=download&id=1UVjLnblrSb-MCLYwgAWiOaSWsH84Nk1e"
//                       : "https://drive.google.com/uc?export=download&id=1iQ3utxkOBO3RgCzBScm5D2_LhkYk3p7K"
//                   }
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   download
//                 >
//                   <Button className="px-5 py-2.5 text-white font-semibold text-sm bg-gradient-to-r from-ecosafe-green to-ecosafe-green-dark hover:brightness-110 rounded-full transition-all w-full sm:w-auto">
//                     <Download className={`h-4 w-4 ${isRTL ? "ml-2" : "mr-2"}`} />
//                     {isRTL ? "الملف التعريفي" : "Company Profile"}
//                   </Button>
//                 </a>

//                 <a
//                   href={
//                     isRTL
//                       ? "https://drive.google.com/uc?export=download&id=12DYDFS2SC6zGUxBQ599BCyaixJO9chIc"
//                       : "https://drive.google.com/uc?export=download&id=1_F8xHHN-LCO0Xc1k2mDSkgpvXaqyfxcZ"
//                   }
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   download
//                 >
//                   <Button className="px-5 py-2.5 text-ecosafe-green font-semibold text-sm border border-ecosafe-green/70 bg-white/10 hover:bg-ecosafe-green hover:text-white rounded-full transition-all w-full sm:w-auto">
//                     <Calendar className={`h-4 w-4 ${isRTL ? "ml-2" : "mr-2"}`} />
//                     {isRTL ? "تقويم ٢٠٢٥" : "Calendar 2025"}
//                   </Button>
//                 </a>
//               </div>
//             </div>

//             {/* Right Side - COMPACT Action Cards */}
//             <div className="space-y-5 max-w-md mx-auto lg:mx-0">
//               {/* Custom Course Card */}
//               <div
//                 onClick={() => setIsCustomCourseFormOpen(true)}
//                 className="cursor-pointer bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4 hover:bg-white/15 hover:scale-[1.02] transition-all group"
//                 role="button"
//                 tabIndex={0}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter" || e.key === " ") setIsCustomCourseFormOpen(true);
//                 }}
//               >
//                 <div className="flex items-center gap-3">
//                   <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-ecosafe-green to-ecosafe-green-dark flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
//                     <Award className="h-5 w-5 text-white" />
//                   </div>
//                   <div className="flex-1 min-w-0">
//                     <h3 className="text-white font-semibold text-sm mb-0.5 truncate">
//                       {isRTL ? "طلب دورة مخصصة" : "Request Custom Course"}
//                     </h3>
//                     <p className="text-white/70 text-xs truncate">
//                       {isRTL ? "حلول تدريبية مصممة لك" : "Tailored training solutions"}
//                     </p>
//                   </div>
//                   <ArrowRight className={`h-4 w-4 text-white/60 flex-shrink-0 ${isRTL ? "rotate-180" : ""}`} />
//                 </div>
//               </div>

//               {/* Search Courses Card */}
//               <div
//                 onClick={handleSearchCourses}
//                 className="cursor-pointer bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4 hover:bg-white/15 hover:scale-[1.02] transition-all group"
//                 role="button"
//                 tabIndex={0}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter" || e.key === " ") handleSearchCourses();
//                 }}
//               >
//                 <div className="flex items-center gap-3">
//                   <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-ecosafe-green to-ecosafe-green-dark flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
//                     <Search className="h-5 w-5 text-white" />
//                   </div>
//                   <div className="flex-1 min-w-0">
//                     <h3 className="text-white font-semibold text-sm mb-0.5 truncate">
//                       {isRTL ? "البحث في الدورات" : "Search All Courses"}
//                     </h3>
//                     <p className="text-white/70 text-xs truncate">
//                       {isRTL ? "اكتشف برامجنا التدريبية" : "Discover 2500+ programs"}
//                     </p>
//                   </div>
//                   <ArrowRight className={`h-4 w-4 text-white/60 flex-shrink-0 ${isRTL ? "rotate-180" : ""}`} />
//                 </div>
//               </div>

//               {/* Request Consultation Card */}
//               <div
//                 onClick={() => setIsConsultationFormOpen(true)}
//                 className="cursor-pointer bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4 hover:bg-white/15 hover:scale-[1.02] transition-all group"
//                 role="button"
//                 tabIndex={0}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter" || e.key === " ") setIsConsultationFormOpen(true);
//                 }}
//               >
//                 <div className="flex items-center gap-3">
//                   <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-ecosafe-green to-ecosafe-green-dark flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
//                     <Calendar className="h-5 w-5 text-white" />
//                   </div>
//                   <div className="flex-1 min-w-0">
//                     <h3 className="text-white font-semibold text-sm mb-0.5 truncate">
//                       {isRTL ? "طلب استشارة" : "Request Consultation"}
//                     </h3>
//                     <p className="text-white/70 text-xs truncate">
//                       {isRTL ? "نصائح خبراء مخصصة" : "Get expert advice"}
//                     </p>
//                   </div>
//                   <ArrowRight className={`h-4 w-4 text-white/60 flex-shrink-0 ${isRTL ? "rotate-180" : ""}`} />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Scroll Indicator */}
//         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
//           <div className="w-6 h-10 border-2 border-white/40 rounded-full flex justify-center p-1">
//             <div className="w-1.5 h-3 bg-ecosafe-green rounded-full animate-pulse"></div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default HeroSection;





import { lazy, Suspense, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Download,
  Calendar,
  Search,
  Award,
  X,
  ExternalLink,
  ArrowRight,
  Users,
  Globe,
  Building,
  CheckCircle,
} from "lucide-react";
const heroImage = "/hero-training.webp";
import RealTimeSearch from "@/components/RealTimeSearch";
import slogan from "../assets/slogan-white.svg";
import { useLanguage } from "@/hooks/useLanguage";

// Dialog forms pull in react-hook-form and react-toastify, so keep them out of the initial bundle
const CustomCourseForm = lazy(() => import("@/components/CustomCourseForm"));
const ConsultationForm = lazy(() => import("@/components/ConsultationForm"));

const HeroSection = () => {
  const [isCustomCourseFormOpen, setIsCustomCourseFormOpen] = useState(false);
  const [isConsultationFormOpen, setIsConsultationFormOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showWelcomePopup, setShowWelcomePopup] = useState(false);
  const navigate = useNavigate();
  const { isRTL } = useLanguage();

  // Show welcome popup after delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWelcomePopup(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // Only block scroll when modals are open
  useEffect(() => {
    if (showWelcomePopup || showSearch || isCustomCourseFormOpen || isConsultationFormOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showWelcomePopup, showSearch, isCustomCourseFormOpen, isConsultationFormOpen]);

  const handleSearchCourses = () => {
    setShowSearch(true);
  };

  const closeWelcomePopup = () => {
    setShowWelcomePopup(false);
  };

  return (
    <>
      <Suspense fallback={null}>
        <CustomCourseForm
          isOpen={isCustomCourseFormOpen}
          onClose={() => setIsCustomCourseFormOpen(false)}
        />

        <ConsultationForm
          isOpen={isConsultationFormOpen}
          onClose={() => setIsConsultationFormOpen(false)}
        />
      </Suspense>

      {/* Welcome Popup Modal */}
      {showWelcomePopup && (
        <div
          className="fixed inset-0 z-[60] bg-black/60 backdrop-blur-md flex items-center justify-center p-4"
          onClick={closeWelcomePopup}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl max-w-md w-full relative animate-in fade-in-90 duration-300"
            onClick={(e) => e.stopPropagation()}
            dir={isRTL ? "rtl" : "ltr"}
          >
            <div className="relative p-6 border-b border-gray-100">
              <button
                onClick={closeWelcomePopup}
                className={`absolute top-4 z-10 text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-lg ${
                  isRTL ? "left-6" : "right-6"
                }`}
                aria-label={isRTL ? "إغلاق" : "Close"}
              >
                <X className="h-5 w-5" />
              </button>
              
              <div className="flex items-center justify-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-ecosafe-green to-ecosafe-green-dark rounded-xl flex items-center justify-center shadow-lg">
                  <Award className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-ecosafe-black">
                    {isRTL ? "انضم إلى مجتمعنا المهني" : "Join Our Professional Community"}
                  </h3>
                </div>
              </div>
            </div>

            <div className="p-6">
              <div className="space-y-3 mb-6">
                <div className="flex items-center gap-3 text-sm text-gray-700">
                  <CheckCircle className="h-4 w-4 text-ecosafe-green flex-shrink-0" />
                  <span>{isRTL ? "آخر الوظائف والتحديثات" : "Latest jobs and updates"}</span>
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-700">
                  <CheckCircle className="h-4 w-4 text-ecosafe-green flex-shrink-0" />
                  <span>{isRTL ? "فرص تدريبية حصرية" : "Exclusive training opportunities"}</span>
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-700">
                  <CheckCircle className="h-4 w-4 text-ecosafe-green flex-shrink-0" />
                  <span>{isRTL ? "شبكة محترفين عالمية" : "Global professional network"}</span>
                </div>
              </div>

              <div className="space-y-3">
                <a
                  href="https://www.linkedin.com/company/ecosafe-for-training-and-consultancy-services/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <Button className="w-full bg-gradient-to-r from-ecosafe-green to-ecosafe-green-dark hover:from-ecosafe-green-dark hover:to-ecosafe-green text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl">
                    <ExternalLink className={`h-4 w-4 ${isRTL ? "ml-2" : "mr-2"}`} />
                    {isRTL ? "تابعنا على لينكدإن" : "Follow on LinkedIn"}
                  </Button>
                </a>

                <button
                  onClick={closeWelcomePopup}
                  className="w-full text-gray-500 hover:text-gray-700 text-sm font-medium transition-colors py-2"
                >
                  {isRTL ? "ربما لاحقاً" : "Maybe Later"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Search Overlay */}
      {showSearch && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
          <div
            className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-ecosafe-green/20 w-full max-w-2xl"
            dir={isRTL ? "rtl" : "ltr"}
          >
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-2xl font-bold text-ecosafe-black">
                  {isRTL ? "البحث عن الدورات التدريبية" : "Search Training Courses"}
                </h3>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => setShowSearch(false)}
                  className="text-ecosafe-gray hover:text-ecosafe-green-dark hover:bg-ecosafe-green/10 rounded-full"
                >
                  <X className="h-5 w-5" />
                </Button>
              </div>
              <RealTimeSearch onClose={() => setShowSearch(false)} />
            </div>
          </div>
        </div>
      )}

      {/* *** COMPACT HERO SECTION - NO SCROLL REQUIRED *** */}
      <section
        className="relative h-screen flex items-center justify-center overflow-hidden"
        dir={isRTL ? "rtl" : "ltr"}
      >
        {/* Background */}
        <div className="absolute inset-0 z-0">
          <img
            src={heroImage}
            width={1920}
            height={1080}
            alt={isRTL ? "بيئة تدريب مهنية" : "Professional training environment"}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-ecosafe-black/70 via-ecosafe-black/50 to-ecosafe-black/30" />
        </div>

        {/* Main Content */}
        <div className="relative z-10 container mx-auto px-4">
          <div className="grid lg:grid-cols-12 gap-6 items-center">
            {/* Left Content - Compact */}
            <div className="lg:col-span-7 space-y-6 text-center lg:text-left flex flex-col items-center lg:items-start">
              {/* Trust Badge */}
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-md rounded-xl text-white border border-white/20">
                <div className="w-2 h-2 bg-ecosafe-green rounded-full animate-pulse"></div>
                <span className="text-sm font-medium">
                  {isRTL ? "٢٥٠٠+ برنامج تدريبي معتمد" : "2500+ Certified Programs"}
                </span>
              </div>

              {/* Main Headline & Slogan */}
              <div className="space-y-4 mt-4 md:mt-6">
                
                <div className="mb-2">
                  <img
                    src={slogan}
                    width={595}
                    height={260}
                    alt={isRTL ? "تدرب لتقود، تعلم مع إيكوسيف" : "Train to Lead, Learn with ECOSAFE"}
                    className="w-64 lg:w-80 h-auto opacity-90 mx-auto lg:mx-0"
                  />
                </div>
              </div>

              {/* Compact Stats */}
              <div className="flex gap-6 py-2 justify-center lg:justify-start">
                <div className="flex items-center gap-2">
                  <Users className="h-4 w-4 text-ecosafe-green" />
                  <div>
                    <div className="text-lg font-bold text-white">3K+</div>
                    <div className="text-white/80 text-xs">{isRTL ? "محترف" : "Professionals"}</div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <Globe className="h-4 w-4 text-ecosafe-green" />
                  <div>
                    <div className="text-lg font-bold text-white">25+</div>
                    <div className="text-white/80 text-xs">{isRTL ? "دولة" : "Countries"}</div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <Building className="h-4 w-4 text-ecosafe-green" />
                  <div>
                    <div className="text-lg font-bold text-white">60+</div>
                    <div className="text-white/80 text-xs">{isRTL ? "شركة" : "Companies"}</div>
                  </div>
                </div>
              </div>

              {/* Compact Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start w-full sm:w-auto">
                <a
                  href={
                    isRTL 
                      ? "https://drive.google.com/uc?export=download&id=1FhrONiLuoIgC0ciA08CAq1NIuuhXZbxd"
                      : "https://drive.google.com/uc?export=download&id=1CecetooFmI1bkgZAy1lAwuxyjW8Dxym9"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  <Button className="px-6 py-2.5 text-white font-semibold text-sm bg-gradient-to-r from-ecosafe-green to-ecosafe-green-dark hover:from-ecosafe-green-dark hover:to-ecosafe-green rounded-lg transition-all duration-200 shadow-lg">
                    <Download className={`h-4 w-4 ${isRTL ? "ml-2" : "mr-2"}`} />
                    {isRTL ? "الملف التعريفي" : "Company Profile"}
                  </Button>
                </a>

                <a
                  href={
                    isRTL 
                      ? "https://drive.google.com/uc?export=download&id=16W-uGg6ZoWgHJ2vDwzoh1Pmgoy7GTeE2"
                      : "https://drive.google.com/uc?export=download&id=1Q6Yc4KT8xTyw0Ue62vir31ps2WTYb4gp"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  <Button className="px-6 py-2.5 text-ecosafe-green font-semibold text-sm border border-ecosafe-green bg-white/10 backdrop-blur-sm hover:bg-ecosafe-green hover:text-white rounded-lg transition-all duration-200">
                    <Calendar className={`h-4 w-4 ${isRTL ? "ml-2" : "mr-2"}`} />
                    {isRTL ? "تقويم ٢٠٢٥" : "2025 Calendar"}
                  </Button>
                </a>
              </div>
            </div>

            {/* Right Side - Compact Action Cards */}
            <div className="lg:col-span-5 space-y-4 max-w-sm mx-auto lg:mx-0">
              {/* Search Courses Card - Primary */}
              <div
                onClick={handleSearchCourses}
                className="cursor-pointer bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4 hover:from-ecosafe-green/30 hover:to-ecosafe-green-dark/30 hover:scale-[1.02] transition-all duration-200 group shadow-lg"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") handleSearchCourses();
                }}
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-ecosafe-green to-ecosafe-green-dark flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <Search className="h-5 w-5 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-white font-semibold text-sm mb-1">
                      {isRTL ? "استكشاف الدورات" : "Explore Courses"}
                    </h3>
                    <p className="text-white/80 text-xs">
                      {isRTL ? "٢٥٠٠+ برنامج تدريبي معتمد" : "2500+ certified programs"}
                    </p>
                  </div>
                  <ArrowRight className={`h-4 w-4 text-white/70 ${isRTL ? "rotate-180" : ""}`} />
                </div>
              </div>

              {/* Custom Course Card */}
              <div
                onClick={() => setIsCustomCourseFormOpen(true)}
                className="cursor-pointer bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4 hover:bg-white/15 hover:scale-[1.02] transition-all duration-200 group"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") setIsCustomCourseFormOpen(true);
                }}
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-ecosafe-green to-ecosafe-green-dark flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <Award className="h-5 w-5 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-white font-semibold text-sm mb-1">
                      {isRTL ? "دورة مخصصة" : "Custom Course"}
                    </h3>
                    <p className="text-white/80 text-xs">
                      {isRTL ? "حلول مصممة لك" : "Tailored solutions"}
                    </p>
                  </div>
                  <ArrowRight className={`h-4 w-4 text-white/70 ${isRTL ? "rotate-180" : ""}`} />
                </div>
              </div>

              {/* Consultation Card */}
              <div
                onClick={() => setIsConsultationFormOpen(true)}
                className="cursor-pointer bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4 hover:bg-white/15 hover:scale-[1.02] transition-all duration-200 group"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") setIsConsultationFormOpen(true);
                }}
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-ecosafe-green to-ecosafe-green-dark flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <Calendar className="h-5 w-5 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-white font-semibold text-sm mb-1">
                      {isRTL ? "استشارة مجانية" : "Free Consultation"}
                    </h3>
                    <p className="text-white/80 text-xs">
                      {isRTL ? "نصائح من خبرائنا" : "Expert advice"}
                    </p>
                  </div>
                  <ArrowRight className={`h-4 w-4 text-white/70 ${isRTL ? "rotate-180" : ""}`} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Minimal Scroll Indicator - Only shows if content is slightly overflowed */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
          <div className="flex flex-col items-center">
            <div className="w-5 h-8 border-2 border-white/30 rounded-full flex justify-center p-1">
              <div className="w-1 h-2 bg-ecosafe-green rounded-full animate-pulse"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;